import { ENVIRONMENTS } from '@belong/common';

const { PRODUCTION } = ENVIRONMENTS;

export const isProd = process.env.NEXT_PUBLIC_ENV === PRODUCTION;

export const isPriceDropsEnabled = true;

export const isBelongXPlacementsEnabled = !isProd;
